module.exports = __webpack_public_path__ + "img/gift.cd2aba3c.svg";